export const notificationTopic = {
  modalCreateDummy: 'modalCreateDummy',
  mountPalletAction: 'mountPalletAction',
  selectPalletAction: 'selectPalletAction',
  modalReplaceDummy: 'modalReplaceDummy',
  modalDismountContainer: 'modalDismountContainer'
};
